<header class="new_sign_nav" id="navbar">
  <div class="container">  
     <nav class="navbar navbar-expand-lg navbar-light main-nav bg-li ght  mx-0 px-0">
<a class="navbar-brand" [routerLink]="['/']"><img loading="lazy" src="../../../../assets/images/logo.png"></a>
<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
<span class="navbar-toggler-icon"></span>
</button>
  <!-- <div class="collapse navbar-collapse" id="navbarNav">
  <ul class="navbar-nav ml-auto">
    <li class="nav-item vip_input_text">
      <input type="number" (keydown)="onDown($event)" (keyup)="onUp($event)" placeholder="Member ID">
        <p *ngIf="isShow == 0">{{get_member_type_admin_homepage_response.string}} - {{get_member_type_admin_homepage_response.friendString}}</p>
    </li>
    <li class="nav-item sign_up">
       <a class="nav-link" (click)="showLoginModal()">SIGN IN  </a>
    </li>
    
  </ul>
 </div> -->
</nav>


</div>
</header>